"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.changeQueryDate = changeQueryDate;
exports.constructPricingKey = constructPricingKey;
exports.default = void 0;
exports.destructPricingKey = destructPricingKey;
exports.formatFareCalendarBulkPrices = formatFareCalendarBulkPrices;
exports.formatLegPricingAirportsFilter = formatLegPricingAirportsFilter;
exports.formatLegPricingTimeFilter = formatLegPricingTimeFilter;
exports.formatOneWayPricingData = formatOneWayPricingData;
exports.formatPricingAirportsFilter = formatPricingAirportsFilter;
exports.formatPricingTimeFilter = formatPricingTimeFilter;
exports.formatRoundTripPricingData = formatRoundTripPricingData;
exports.generateFareCalendarDateRange = generateFareCalendarDateRange;
exports.generateFareCalenderLeg = generateFareCalenderLeg;
exports.generateFareCalenderRequest = generateFareCalenderRequest;
exports.generatePriceColorMapWithSummary = generatePriceColorMapWithSummary;
exports.getBaseDateForFareCalender = getBaseDateForFareCalender;
exports.getCheapestPrice = getCheapestPrice;
exports.getInsuranceAirlineFilter = getInsuranceAirlineFilter;
exports.getPriceChangeDetails = getPriceChangeDetails;
exports.getPricingCheapestPrice = getPricingCheapestPrice;
exports.getPricingCompleteness = getPricingCompleteness;
exports.getPricingFilters = getPricingFilters;
exports.getPricingMap = getPricingMap;
exports.getValidPrices = getValidPrices;
exports.initializePricingData = initializePricingData;
exports.shouldDisableDeparture = shouldDisableDeparture;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _queryString = _interopRequireDefault(require("query-string"));
var _sub_days = _interopRequireDefault(require("date-fns/sub_days"));
var _add_days = _interopRequireDefault(require("date-fns/add_days"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _is_after = _interopRequireDefault(require("date-fns/is_after"));
var _difference_in_calendar_days = _interopRequireDefault(require("date-fns/difference_in_calendar_days"));
var _is_today = _interopRequireDefault(require("date-fns/is_today"));
var _is_valid = _interopRequireDefault(require("date-fns/is_valid"));
var _is_tomorrow = _interopRequireDefault(require("date-fns/is_tomorrow"));
var _compact2 = _interopRequireDefault(require("lodash/compact"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _min2 = _interopRequireDefault(require("lodash/min"));
var _minBy2 = _interopRequireDefault(require("lodash/minBy"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _split2 = _interopRequireDefault(require("lodash/split"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _search = require("./search.utils");
var _constants = require("../constants");
var _fareCalendar = require("../constants/fare-calendar.constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getBaseDateForFareCalender(date, range) {
  if (range === void 0) {
    range = _constants.PRICING_DATE_RANGE;
  }
  var dateObj = new Date(date);
  var todayDateObj = new Date();
  var formattedDate = (0, _format.default)(dateObj, _constants.DEFAULT_DATE_FORMAT);
  var formattedToday = (0, _format.default)(todayDateObj, _constants.DEFAULT_DATE_FORMAT);
  var daysToSubtract = Math.floor(range / 2);
  var daysDifference = (0, _difference_in_calendar_days.default)(formattedDate, formattedToday);
  if (daysDifference < daysToSubtract) {
    daysToSubtract = daysDifference;
  }
  return (0, _sub_days.default)(dateObj, daysToSubtract);
}
function generateFareCalendarDateRange(currentDate, range) {
  if (range === void 0) {
    range = _constants.PRICING_DATE_RANGE;
  }
  var baseDate = getBaseDateForFareCalender(currentDate, range);
  var dateRangeArray = [];
  if (!(0, _is_valid.default)(baseDate)) {
    return dateRangeArray;
  }
  for (var index = 0; index < range; index++) {
    var nextDate = (0, _format.default)((0, _add_days.default)(baseDate, index), _constants.DEFAULT_DATE_FORMAT);
    dateRangeArray.push(nextDate);
  }
  return dateRangeArray;
}
function generateFareCalenderLeg(_ref) {
  var originId = _ref.originId,
    destinationId = _ref.destinationId,
    date = _ref.date,
    _ref$range = _ref.range,
    range = _ref$range === void 0 ? _constants.PRICING_DATE_RANGE : _ref$range;
  var leg = {
    originId: originId,
    destinationId: destinationId,
    departureFrom: date,
    departureTo: date
  };
  var dateArray = generateFareCalendarDateRange(date, range);
  var dateArrayLength = dateArray.length;
  if (dateArrayLength > 0) {
    leg.departureFrom = dateArray[0];
    leg.departureTo = dateArray[dateArrayLength - 1];
  }
  return leg;
}
function generateFareCalenderRequest(_ref2) {
  var query = _ref2.query,
    _ref2$stops = _ref2.stops,
    stops = _ref2$stops === void 0 ? [] : _ref2$stops,
    _ref2$airline = _ref2.airline,
    airline = _ref2$airline === void 0 ? [] : _ref2$airline,
    _ref2$timeSlots = _ref2.timeSlots,
    timeSlots = _ref2$timeSlots === void 0 ? {} : _ref2$timeSlots,
    _ref2$airports = _ref2.airports,
    airports = _ref2$airports === void 0 ? {} : _ref2$airports,
    _ref2$range = _ref2.range,
    range = _ref2$range === void 0 ? _constants.PRICING_DATE_RANGE : _ref2$range;
  var _getParamsFromQuery = (0, _search.getParamsFromQuery)(query),
    cabin = _getParamsFromQuery.cabin,
    isRoundTrip = _getParamsFromQuery.isRoundTrip,
    departureDate = _getParamsFromQuery.departureDate,
    originId = _getParamsFromQuery.originId,
    destinationId = _getParamsFromQuery.destinationId,
    returnDate = _getParamsFromQuery.returnDate;
  var leg = [];
  leg.push(generateFareCalenderLeg({
    originId: originId,
    destinationId: destinationId,
    date: departureDate,
    range: range
  }));
  if (isRoundTrip && typeof returnDate === "string") {
    leg.push(generateFareCalenderLeg({
      originId: destinationId,
      destinationId: originId,
      date: returnDate,
      range: range
    }));
  }
  return {
    leg: leg,
    cabin: cabin,
    pax: (0, _search.getPaxFromQuery)(query),
    stops: (0, _isArray2.default)(stops) ? stops : [],
    airline: (0, _isArray2.default)(airline) ? airline : [],
    timeSlots: timeSlots,
    airports: airports
  };
}
function initializePricingData(_ref3) {
  var payload = _ref3.payload,
    query = _ref3.query,
    range = _ref3.range,
    _ref3$convertPrice = _ref3.convertPrice,
    convertPrice = _ref3$convertPrice === void 0 ? function (v) {
      return v;
    } : _ref3$convertPrice;
  var _getParamsFromQuery2 = (0, _search.getParamsFromQuery)(query),
    isRoundTrip = _getParamsFromQuery2.isRoundTrip,
    departureDate = _getParamsFromQuery2.departureDate,
    returnDate = _getParamsFromQuery2.returnDate;
  if (isRoundTrip && typeof returnDate === "string") {
    return formatRoundTripPricingData({
      payload: payload,
      departureDate: departureDate,
      returnDate: returnDate,
      range: range,
      convertPrice: convertPrice
    });
  }
  return formatOneWayPricingData({
    payload: payload,
    departureDate: departureDate,
    range: range,
    convertPrice: convertPrice
  });
}
function formatOneWayPricingData(_ref4) {
  var _ref4$payload = _ref4.payload,
    payload = _ref4$payload === void 0 ? {} : _ref4$payload,
    baseDepartureDate = _ref4.departureDate,
    range = _ref4.range,
    _ref4$convertPrice = _ref4.convertPrice,
    convertPrice = _ref4$convertPrice === void 0 ? function (v) {
      return v;
    } : _ref4$convertPrice;
  var pricingData = {};
  var departureDateArray = generateFareCalendarDateRange(baseDepartureDate, range);
  (0, _each2.default)(departureDateArray, function (departureDate) {
    var _payload$departureDat, _payload$departureDat2;
    pricingData[departureDate] = {
      departureDate: departureDate,
      price: convertPrice(payload === null || payload === void 0 ? void 0 : (_payload$departureDat = payload[departureDate]) === null || _payload$departureDat === void 0 ? void 0 : _payload$departureDat.price),
      baseDepartureDate: baseDepartureDate,
      airline: (0, _get2.default)(payload, departureDate + ".airline", null),
      source: (payload === null || payload === void 0 ? void 0 : (_payload$departureDat2 = payload[departureDate]) === null || _payload$departureDat2 === void 0 ? void 0 : _payload$departureDat2.source) || ""
    };
  });
  return pricingData;
}
function formatRoundTripPricingData(_ref5) {
  var payload = _ref5.payload,
    departureDate = _ref5.departureDate,
    returnDate = _ref5.returnDate,
    range = _ref5.range,
    convertPrice = _ref5.convertPrice;
  var pricingData = {};
  var departureDateArray = generateFareCalendarDateRange(departureDate, range);
  var returnDateArray = generateFareCalendarDateRange(returnDate, range);
  (0, _each2.default)(departureDateArray, function (departureDate) {
    (0, _each2.default)(returnDateArray, function (returnDate) {
      var _payload$pricingKey;
      var pricingKey = constructPricingKey(departureDate, returnDate);
      var isInvalidItem = (0, _is_after.default)(new Date(departureDate), new Date(returnDate));
      var price = isInvalidItem ? -1 : convertPrice((0, _get2.default)(payload, pricingKey + ".price"));
      var airline = (0, _get2.default)(payload, pricingKey + ".airline", null);
      var source = (payload === null || payload === void 0 ? void 0 : (_payload$pricingKey = payload[pricingKey]) === null || _payload$pricingKey === void 0 ? void 0 : _payload$pricingKey.source) || "";
      pricingData[pricingKey] = {
        price: price,
        departureDate: departureDate,
        returnDate: returnDate,
        airline: airline,
        source: source
      };
    });
  });
  return pricingData;
}
function getPricingCheapestPrice(pricingMap) {
  var validPricingItems = (0, _filter2.default)(pricingMap, function (_ref6) {
    var price = _ref6.price;
    return Number(price) > 0;
  });
  var minPricingItem = (0, _minBy2.default)(validPricingItems, "price");
  return minPricingItem === null || minPricingItem === void 0 ? void 0 : minPricingItem.price;
}
function getPriceChangeDetails(currentPrice, nextPrice) {
  var isInvalidDate = currentPrice === -1;
  var isNotDeterminedPrice = currentPrice === undefined;
  var isNotAvailablePrice = currentPrice === null || nextPrice === null;
  var shouldComparePrices = Number(nextPrice) > 0 && Number(currentPrice) > 0;
  if (isInvalidDate) {
    return {
      price: currentPrice,
      priceChange: 0
    };
  }
  if (isNotDeterminedPrice || isNotAvailablePrice) {
    return {
      price: nextPrice,
      priceChange: 0
    };
  }
  if (shouldComparePrices) {
    return {
      price: nextPrice,
      priceChange: Number(nextPrice) - Number(currentPrice)
    };
  }
  return {
    price: currentPrice,
    priceChange: 0
  };
}
function constructPricingKey(departureDate, returnDate) {
  if (returnDate) {
    return [departureDate, returnDate].join(_constants.PRICING_KEY_SEPARATOR);
  }
  return departureDate;
}
function destructPricingKey(pricingKey) {
  return (0, _split2.default)(pricingKey, _constants.PRICING_KEY_SEPARATOR);
}
function getPricingMap(_ref7) {
  var pricingData = _ref7.pricingData,
    $currency = _ref7.$currency;
  var cheapestPrice = getPricingCheapestPrice(pricingData);
  return (0, _mapValues2.default)(pricingData, function (item, key) {
    var price = (0, _get2.default)(item, "price");
    var _destructPricingKey = destructPricingKey(key),
      departureDate = _destructPricingKey[0],
      returnDate = _destructPricingKey[1];
    var baseDepartureDate = (0, _get2.default)(item, "baseDepartureDate", Date.now());
    var formattedBaseDepDate = (0, _format.default)(baseDepartureDate, _constants.DEFAULT_DATE_FORMAT);
    var formattedDepDate = (0, _format.default)(departureDate, _constants.DEFAULT_DATE_FORMAT);
    return {
      pricingKey: key,
      departureDate: departureDate,
      returnDate: returnDate,
      price: price,
      displayPrice: $currency.formatPriceWithDecimals(price, 0),
      currency: $currency.currentCurrency,
      isCheapest: Number(price) > 0 && Number(price) <= Number(cheapestPrice),
      isValid: Number(price) > 0,
      isNotValid: price === -1,
      isNotDetermined: price === undefined,
      isNotAvailable: price === null,
      daysDiff: (0, _difference_in_calendar_days.default)(formattedDepDate, formattedBaseDepDate),
      airline: (0, _get2.default)(item, "airline", null),
      source: (item === null || item === void 0 ? void 0 : item.source) || ""
    };
  });
}
function formatLegPricingAirportsFilter(airportsQuery, index) {
  return (0, _filter2.default)((0, _split2.default)((0, _split2.default)(airportsQuery, _constants.FILTER_PARAM_AIRPORT_SEPARATOR)[index], _constants.FILTER_PARAM_LEG_ITEM_SEPARATOR), function (item) {
    return item !== _constants.FILTER_PARAM_ALL_ITEM;
  });
}
function formatPricingAirportsFilter(airportsQuery) {
  return (0, _map2.default)((0, _split2.default)(airportsQuery, _constants.FILTER_PARAM_LEG_SEPARATOR), function (airportSubQuery) {
    return {
      departure: formatLegPricingAirportsFilter(airportSubQuery, 0),
      arrivals: formatLegPricingAirportsFilter(airportSubQuery, 1)
    };
  });
}
function formatLegPricingTimeFilter(timeFilerQuery) {
  if (timeFilerQuery && timeFilerQuery !== _constants.FILTER_PARAM_ALL_ITEM) {
    var timeFilerParams = (0, _split2.default)(timeFilerQuery, _constants.FILTER_PARAM_LEG_ITEM_SEPARATOR);
    return (0, _map2.default)(timeFilerParams, function (timeSlot) {
      return _constants.TIME_FILTER_FARE_CALENDAR_MAP[timeSlot];
    });
  }
  return [];
}
function formatPricingTimeFilter(departureTimeParam, arrivalTimeParam) {
  var dTime = (0, _split2.default)(departureTimeParam, _constants.FILTER_PARAM_LEG_SEPARATOR);
  var aTime = (0, _split2.default)(arrivalTimeParam, _constants.FILTER_PARAM_LEG_SEPARATOR);
  return (0, _map2.default)(_constants.FLIGHT_DIRECTIONS, function (direction, index) {
    return {
      departure: formatLegPricingTimeFilter(dTime[index]),
      arrivals: formatLegPricingTimeFilter(aTime[index])
    };
  });
}
function getPricingFilters(filtersQuery, filtersData) {
  var filtersObject = _queryString.default.parse(filtersQuery);
  var filters = {
    stops: [],
    airline: [],
    timeSlots: {},
    airports: {}
  };
  var allInsuranceAirlinesAvailable = (0, _get2.default)(filtersData, "airline");
  if (!(0, _isPlainObject2.default)(filtersObject)) return filters;
  var stopParam = filtersObject[_constants.FILTER_PARAMS_MAP.stop];
  var airlineParam = filtersObject[_constants.FILTER_PARAMS_MAP.airline];
  var arrivalTimeParam = filtersObject[_constants.FILTER_PARAMS_MAP.arrivalTime];
  var departureTimeParam = filtersObject[_constants.FILTER_PARAMS_MAP.departureTime];
  var airportParam = filtersObject[_constants.FILTER_PARAMS_MAP.airport];
  var insuranceParam = filtersObject[_constants.FILTER_PARAMS_MAP.insuranceOnly];
  if (stopParam) {
    filters.stops = (0, _map2.default)((0, _split2.default)(stopParam, _constants.FILTER_PARAM_LEG_ITEM_SEPARATOR), function (stop) {
      return parseInt(stop, 10);
    });
  }
  if (airlineParam || insuranceParam) {
    var airlinesStr = (0, _split2.default)(airlineParam, _constants.FILTER_PARAM_LEG_SEPARATOR)[0];
    var airlines = airlinesStr !== _constants.FILTER_PARAM_ALL_ITEM ? (0, _split2.default)(airlinesStr, _constants.FILTER_PARAM_LEG_ITEM_SEPARATOR) : [];
    filters.airline = insuranceParam ? getInsuranceAirlineFilter(airlines, allInsuranceAirlinesAvailable) : airlines;
  }
  if (airportParam) {
    var airports = formatPricingAirportsFilter(airportParam);
    filters.airports = {
      going: airports[0],
      return: airports[1]
    };
  }
  if (departureTimeParam || arrivalTimeParam) {
    var timeSlots = formatPricingTimeFilter(departureTimeParam, arrivalTimeParam);
    filters.timeSlots = {
      going: timeSlots[0],
      return: timeSlots[1]
    };
  }
  return filters;
}
function getPricingCompleteness(pricingMap) {
  return (0, _size2.default)((0, _filter2.default)(pricingMap, function (cell) {
    return cell.isValid;
  })) / (0, _size2.default)(pricingMap) * 100;
}
function getInsuranceAirlineFilter(airlineFilters, insuranceAirlines) {
  var availableInsuranceAirline = (0, _intersection2.default)(insuranceAirlines, _constants.AIRLINES_WITH_COVERAGE);
  return (0, _compact2.default)(airlineFilters).length > 0 ? (0, _intersection2.default)(availableInsuranceAirline, airlineFilters) : availableInsuranceAirline;
}
function changeQueryDate(_ref8) {
  var _ref8$updateReturnDat = _ref8.updateReturnDate,
    updateReturnDate = _ref8$updateReturnDat === void 0 ? false : _ref8$updateReturnDat,
    _ref8$daysCount = _ref8.daysCount,
    daysCount = _ref8$daysCount === void 0 ? 1 : _ref8$daysCount,
    _ref8$query = _ref8.query,
    query = _ref8$query === void 0 ? "" : _ref8$query;
  var _getParamsFromQuery3 = (0, _search.getParamsFromQuery)(query),
    departureDate = _getParamsFromQuery3.departureDate,
    returnDate = _getParamsFromQuery3.returnDate;
  if (updateReturnDate) {
    var _updateReturn = returnDate ? (0, _format.default)((0, _add_days.default)(new Date(returnDate), daysCount), _constants.DEFAULT_DATE_FORMAT) : "";
    return (0, _search.formSearchQueryFromDates)(query, departureDate, _updateReturn);
  }
  var updatedDepartureDate = (0, _format.default)((0, _add_days.default)(new Date(departureDate), daysCount), _constants.DEFAULT_DATE_FORMAT);
  var updateReturn = returnDate || "";
  return (0, _search.formSearchQueryFromDates)(query, updatedDepartureDate, updateReturn);
}
function shouldDisableDeparture(departureDate, returnDate) {
  if ((0, _is_today.default)(departureDate)) {
    return (0, _difference_in_calendar_days.default)(returnDate, departureDate) <= 2;
  }
  if ((0, _is_tomorrow.default)(departureDate)) {
    return (0, _difference_in_calendar_days.default)(returnDate, departureDate) < 2;
  }
  return (0, _is_after.default)(departureDate, returnDate);
}
function getValidPrices(data) {
  return (0, _values2.default)(data).map(function (item) {
    return item.price;
  }).filter(function (price) {
    return price > 0;
  });
}
function getCheapestPrice(data) {
  var prices = getValidPrices(data);
  return prices.length > 0 ? (0, _min2.default)(prices) : undefined;
}
function generatePriceColorMapWithSummary(data, cheapestPrice, thresholds) {
  var _thresholds$greenPerc, _thresholds$yellowPer;
  var colorMap = new Map();
  var moderate = null;
  var high = null;
  if (!cheapestPrice) {
    return {
      colorMap: colorMap,
      priceSummary: {
        cheapest: 0,
        moderate: null,
        high: null
      }
    };
  }
  var greenThreshold = (_thresholds$greenPerc = thresholds === null || thresholds === void 0 ? void 0 : thresholds.greenPercentage) !== null && _thresholds$greenPerc !== void 0 ? _thresholds$greenPerc : _fareCalendar.FARE_CALENDAR_PRICE_THRESHOLDS.GREEN_PERCENTAGE;
  var yellowThreshold = (_thresholds$yellowPer = thresholds === null || thresholds === void 0 ? void 0 : thresholds.yellowPercentage) !== null && _thresholds$yellowPer !== void 0 ? _thresholds$yellowPer : _fareCalendar.FARE_CALENDAR_PRICE_THRESHOLDS.YELLOW_PERCENTAGE;
  Object.entries(data).forEach(function (_ref9) {
    var date = _ref9[0],
      priceData = _ref9[1];
    var price = priceData.price;
    if (price <= 0) return;
    var percentageAboveCheapest = (price - cheapestPrice) / cheapestPrice * 100;
    if (percentageAboveCheapest <= greenThreshold) {
      colorMap.set(date, _fareCalendar.FARE_CALENDAR_PRICE_COLOR_MAP.GREEN);
    } else if (percentageAboveCheapest <= yellowThreshold) {
      colorMap.set(date, _fareCalendar.FARE_CALENDAR_PRICE_COLOR_MAP.YELLOW);
      if (moderate === null || price < moderate) {
        moderate = price;
      }
    } else {
      colorMap.set(date, _fareCalendar.FARE_CALENDAR_PRICE_COLOR_MAP.RED);
      if (high === null || price < high) {
        high = price;
      }
    }
  });
  return {
    colorMap: colorMap,
    priceSummary: {
      cheapest: cheapestPrice,
      moderate: moderate,
      high: high
    }
  };
}
function formatFareCalendarBulkPrices(data, $currency) {
  return (0, _mapValues2.default)(data, function (datePrice) {
    var convertedPrice = $currency.convertPrice(datePrice.price);
    return _objectSpread(_objectSpread({}, datePrice), {}, {
      price: convertedPrice,
      displayPrice: $currency.formatPriceWithDecimals(convertedPrice, 0),
      currency: $currency.currentCurrency
    });
  });
}
var _default = exports.default = {
  getPricingFilters: getPricingFilters,
  constructPricingKey: constructPricingKey,
  generateFareCalendarDateRange: generateFareCalendarDateRange,
  generateFareCalenderRequest: generateFareCalenderRequest,
  initializePricingData: initializePricingData,
  getPriceChangeDetails: getPriceChangeDetails,
  getPricingMap: getPricingMap,
  getPricingCompleteness: getPricingCompleteness,
  changeQueryDate: changeQueryDate,
  shouldDisableDeparture: shouldDisableDeparture,
  getValidPrices: getValidPrices,
  getCheapestPrice: getCheapestPrice,
  generatePriceColorMapWithSummary: generatePriceColorMapWithSummary,
  formatFareCalendarBulkPrices: formatFareCalendarBulkPrices
};